import React from 'react';
import { useTranslation } from 'react-i18next';
import { Users, BarChart3, Trophy } from 'lucide-react';
import '../styles/FantasyMain.css';

const FantasyMainPage = ({ setActiveTab }) => {
  const { t } = useTranslation();

  const sections = [
    {
      id: 10,
      title: t('fantasy.players.title'),
      description: t('fantasy.players.name'),
      icon: Users,
      color: 'bg-info',
      tabIndex: 10,
      badge: '650+'
    },
    {
      id: 11,
      title: t('fantasy.stats.title'),
      description: t('fantasy.stats.gameweek'),
      icon: BarChart3,
      color: 'bg-success',
      tabIndex: 11,
      badge: '38'
    },
    {
      id: 12,
      title: t('fantasy.fixtures.title'),
      description: t('fantasy.fixtures.gameweek'),
      icon: Trophy,
      color: 'bg-primary',
      tabIndex: 12,
      badge: '380'
    },
    {
      id: 13,
      title: t('fantasy.leaderboard.title'),
      description: t('fantasy.leaderboard.fantasy_points'),
      icon: Trophy,
      color: 'bg-danger',
      tabIndex: 13,
      badge: 'Live'
    }
  ];

  return (
    <div className="fantasy-main-page">
      {/* Header */}
      <header className="fantasy-main-header">
        <div className="d-flex align-items-center gap-3 mb-0">
          <Trophy size={40} className="text-white" aria-hidden="true" />
          <div>
            <h1 className="mb-0">{t('fantasy.title')}</h1>
            <p className="mb-0 text-white-50">{t('fantasy.description')}</p>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <section className="fantasy-main-sections" aria-label="Fantasy sections">
        <div className="fantasy-cards-grid">
          {sections.map((section) => {
            const IconComponent = section.icon;
            return (
              <article
                key={section.id}
                className="fantasy-main-card"
                onClick={() => setActiveTab(section.tabIndex)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    setActiveTab(section.tabIndex);
                  }
                }}
              >
                <div className={`fantasy-card-icon ${section.color}`}>
                  <IconComponent size={48} aria-hidden="true" />
                </div>

                <div className="fantasy-card-content">
                  <h2 className="fantasy-card-title">{section.title}</h2>
                  <p className="fantasy-card-description">{section.description}</p>

                  <div className="fantasy-card-badge">
                    <span className="badge bg-light text-dark">{section.badge}</span>
                  </div>
                </div>

                <div className="fantasy-card-footer">
                  <span className="fantasy-card-link">
                    {t('fantasy.title')} →
                  </span>
                </div>
              </article>
            );
          })}
        </div>
      </section>

      {/* Info Section */}
      <section className="fantasy-main-info mt-5">
        <div className="row g-4">
          <div className="col-12 col-md-6">
            <article className="info-box">
              <h3 className="mb-3">📊 {t('fantasy.title')} {t('quickStats')}</h3>
              <ul className="list-unstyled">
                <li className="mb-2">
                  <strong>{t('fantasy.players.title')}:</strong> {t('fantasy.players.total')}
                </li>
                <li className="mb-2">
                  <strong>{t('fantasy.stats.title')}:</strong> 38 {t('fantasy.stats.gameweek')}s
                </li>
                <li className="mb-2">
                  <strong>{t('fantasy.fixtures.title')}:</strong> 380 {t('fantasy.fixtures.total')}
                </li>
                <li>
                  <strong>{t('fantasy.leaderboard.title')}:</strong> {t('fantasy.leaderboard.total_players')}
                </li>
              </ul>
            </article>
          </div>

          <div className="col-12 col-md-6">
            <article className="info-box">
              <h3 className="mb-3">✨ {t('howToUse')}</h3>
              <ul className="list-unstyled">
                <li className="mb-2">
                  📋 {t('fantasy.players.title')}: Visualizza tutti i giocatori e le loro statistiche
                </li>
                <li className="mb-2">
                  📈 {t('fantasy.stats.title')}: Analizza le statistiche per giornata di campionato
                </li>
                <li className="mb-2">
                  ⚽ {t('fantasy.fixtures.title')}: Consulta le partite e i loro risultati
                </li>
                <li>
                  🏆 {t('fantasy.leaderboard.title')}: Seguici la classifica aggiornata in tempo reale
                </li>
              </ul>
            </article>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FantasyMainPage;
